export default "__VITE_ASSET__pmAgjp2l__"